/* eslint-disable react/prop-types */
import classnames from 'classnames'
import React from 'react'

export const HydroCard: React.FC<{
  imgSrc?: string
  imgAlt?: string
  title: string
  subtitle?: string
  href: string
  icon: string
  classes?: {
    [id: string]: any
  }
}> = ({ imgSrc, imgAlt, title, subtitle, href, icon, classes }) => {
  return (
    <div
      className={classnames('column', {
        'is-3-desktop': true,
        'is-4-tablet': true,
        'is-12-mobile': true,
        ...classes,
      })}
    >
      <a href={href}>
        <div className="card">
          {imgSrc && (
            <div className="card-image">
              <figure className="image is-2by1">
                <img src={imgSrc} alt={imgAlt} />
              </figure>
            </div>
          )}
          <div className="card-content icon-text">
            <p className="title is-6">
              <span className="icon has-text-info">
                <i className={`far ${icon}`} />
              </span>
              <span>{title}</span>
            </p>
            {subtitle && <p className="subtitle is-6">{subtitle}</p>}
          </div>
        </div>
      </a>
    </div>
  )
}
